import { Box, Flex, Text } from '@theme-ui/components';
import styled from '@emotion/styled';

import { H4 } from '@app/components/typography';
import { rem } from '@app/styles/theme/layout';

export const Wrapper = styled(Flex)`
  border: ${rem(1)} solid ${({ theme }) => theme.colors.productBorderColor};
  padding: ${rem(25)} ${rem(25)} ${rem(15)};
  height: 100%;
  flex-direction: column;
`;

export const Title = styled(H4)`
  margin-bottom: ${rem(20)};
`;

export const Picture = styled.img`
  display: block;
  margin: 0 auto ${rem(10)};
  max-width: 100%;
`;

export const Price = styled(Text)`
  white-space: pre;
  font-weight: 600;
  font-size: ${rem(20)};
  display: block;
`;

export const FeaturesList = styled.ul`
  padding: 0;
  li {
    position: relative;
    list-style: none;
    font-size: ${rem(14)};
    padding-left: ${rem(14)};
    padding-bottom: ${rem(5)};
    &:before {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      top: ${rem(4)};
      left: 0;
      border-top: ${rem(4)} solid transparent;
      border-left: ${rem(4)} solid ${({ theme }) => theme.colors.black};
      border-bottom: ${rem(4)} solid transparent;
    }
  }
`;

export const Content = styled(Box)`
  ul {
    padding: 0;
    li {
      font-size: ${rem(14)};
      padding-bottom: ${rem(5)};
      position: relative;
      list-style: none;
      padding-left: ${rem(14)};
      &:before {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        border-top: ${rem(4)} solid transparent;
        border-left: ${rem(4)} solid ${({ theme }) => theme.colors.black};
        border-bottom: ${rem(4)} solid transparent;
        top: ${rem(4)};
        left: 0;
      }
    }
  }

  a {
    &:hover {
      text-decoration: underline;
      color: ${({ theme }) => theme.colors.protectedContentLinkHover};
      transition: all 0.3s;
    }
  }
`;
